export interface production_info {
  productionList: Array<any>,

}

export default class data implements production_info{

  productionList = [
    [
      {
        img: require('../../assets/production/content-img1_1.png'),
        title: '多渠道接入',
        text: '平台支持APP、微信、二维码、网页、电话等多种方式提交服务请求，多渠道接入，系统生成工单统一处理，让客户随时享受售后服务。'
      },
      {
        img: require('../../assets/production/content-img1_2.png'),
        title: '快速受理',
        text: '客户工单信息传到系统后，客服人员会根据当前情况选择自动或手动的方式对工单进行受理，在最短的时间内响应客户需求。'
      },
      {
        img: require('../../assets/production/content-img1_3.png'),
        title: '智能派单',
        text: '用户可根据自身情况进行自动派单设置，系统将根据用户设置智能派工，节约用户时间，降低人力成本，也支持手动派单和工单池抢单，满足多样化派单场景。'
      },
      {
        img: require('../../assets/production/content-img1_4.png'),
        title:'高效协同',
        text: '以工单驱动不同角色人员协同，系统实时更新，低时延，高效率，实现同一平台信息高效互通，快速处理客户服务问题，全程跟踪可控。'
      }
    ],
    [
      {
        img: require('../../assets/production/content-img2_1.png'),
        title: '可视化设备状态管理',
        text: '所有设备包括位置、保修期、品牌、维修记录等详细信息都可录入系统，平台将以表格形式罗列各类信息，清晰展现企业设备档案，保障资产安全可控。'
      },
      {
        img: require('../../assets/production/content-img2_2.png'),
        title: '自动化设备使用统计',
        text: '系统将完整记录企业设备养护成本、开机率、故障率等信息，帮助企业计算不同设备的使用频率和后期成本，提高资产运营效率。'
      },
      {
        img: require('../../assets/production/content-img2_3.png'),
        title: '科学化设备服务计划',
        text: '分析设备数据和维护记录来预测机器缺陷，维保养护到期提醒，建议最佳维护 计划以避免或减少生产宕机可能性，提高设备可用率。'
      }
    ],
    [
      {
        img: require('../../assets/production/content-img3_1.png'),
        title: '明确的备件动向',
        text: '备件条码或编号具有唯一性，用户可利用平台功能搜索备件的信息，精确跟踪每个备件的出入库、领取与归还，完全掌握每个备件的去向。'
      },
      {
        img: require('../../assets/production/content-img3_2.png'),
        title: '便捷的备件调拨',
        text: '用户可通过申请、审批、发货与收货等环节，一站式处理，轻松完成备件调拨，所有操作线上完成，省时省力省心。'
      },
      {
        img: require('../../assets/production/content-img3_3.png'),
        title: '高效的库存管控',
        text: '通过库存总览、盘点、实时预警等功能，清晰了解备件使用情况，帮助维持库存稳定，科学制定备件管理计划，让备件达到供需平衡从而降低企业仓储成本。'
      }
    ],
    [
      {
        img: require('../../assets/production/content-img4_1.png'),
        title: '客户资料',
        text: '一个窗口关联查询客户信息、联系人信息、设备清单、服务记录、工单进展，反馈记录等所有信息。'
      },
      {
        img: require('../../assets/production/content-img4_2.png'),
        title: '智能信息推送',
        text: '系统将根据工单进度，通过邮件、短信、微信等多种渠道智能反馈信息，全程自动化，第一时间直达客户。'
      },
      {
        img: require('../../assets/production/content-img4_3.png'),
        title: '客户自助服务',
        text: '可由客户发起售后服务请求，随时查看工单最新进度、过往服务记录，客户实施监督并进行服务评价，提供企业与客户间接交流平台。'
      }
    ],
    [
      {
        img: require('../../assets/production/content-img5_1.png'),
        title: '工单质量统计分析',
        text: '通过对工单进行多维度的统计分析，真实反应出售后服务的品质，为企业提高服务质量提供数据支持。'
      },
      {
        img: require('../../assets/production/content-img5_2.png'),
        title: '备件调用统计分析',
        text: '通过多维度分析与监管备件使用情况，在确保维修需求的同时，降低备件资源占有率，实现科学的备件管理计划。'
      },
      {
        img: require('../../assets/production/content-img5_3.png'),
        title: '设备明细统计分析',
        text: '对设备的档案、工单、养护成本、故障类别、开机率等进行多维度分析，生成各类汇总表和明细表，帮助用户全方位了解设备状况，个性化定制维护策略。'
      }
    ],
  ]
}

